// Mock data for EWRF Malaysia website

export const stats = [
  { id: 1, number: '47+', label: 'Years of Impact', icon: '📊' },
  { id: 2, number: '15000+', label: 'Lives Touched', icon: '👥' },
  { id: 3, number: '500+', label: 'Volunteers', icon: '🤝' },
  { id: 4, number: '120+', label: 'Partner Schools', icon: '🏫' }
];

export const programmes = [
  {
    id: 1,
    icon: '🏕️',
    badge: 'Long-Term Support',
    title: 'Civil Society Intervention Plus',
    description: 'A long-term support programme for at-risk students, starting with a 21-day camp in Standard 6 and continuing with mentorship throughout secondary school.',
    link: '#programmes'
  },
  {
    id: 2,
    icon: '📚',
    badge: '30-Week Programme',
    title: 'Language for Juniors',
    description: 'Designed to develop the self-esteem of primary level students through the English Language, building communication skills and confidence.',
    link: '#programmes'
  },
  {
    id: 3,
    icon: '💬',
    badge: 'Core Activity',
    title: 'Counselling',
    description: 'EWRF\'s core supporting activity, addressing the emotional and behavioural challenges of students through professional one-on-one sessions.',
    link: '#programmes'
  },
  {
    id: 4,
    icon: '🧭',
    badge: 'Career Development',
    title: 'Career Coaching & Guidance',
    description: 'Career guidance to students and job seekers through workshops that help identify skills, set goals, and explore educational pathways.',
    link: '#programmes'
  },
  {
    id: 5,
    icon: '🏥',
    badge: 'Welfare',
    title: 'Welfare & Medical Aid',
    description: 'Direct assistance ensuring beneficiaries receive the help they require to carry on their day-to-day activities with dignity.',
    link: '#programmes'
  },
  {
    id: 6,
    icon: '🤝',
    badge: 'Volunteer Programme',
    title: 'Volunteer Induction',
    description: 'Introduces new recruits to EWRF\'s initiatives and enhances skills of current volunteers across our flagship programmes.',
    link: '#programmes'
  }
];

export const testimonials = [
  {
    id: 1,
    initial: 'P',
    name: 'Puan Suraya Abdullah',
    role: 'Parent • CSI Plus Beneficiary',
    content: 'Before joining the CSI Plus 21-day camp, my son barely spoke in class and had no confidence in his studies. After the camp and with his mentor\'s guidance, he became a different child – participating actively, improving his grades, and even helping younger students. EWRF didn\'t just change his academic life; they changed our whole family\'s outlook.'
  },
  {
    id: 2,
    initial: 'L',
    name: 'Madam Lim Wei Ling',
    role: 'Primary School Teacher',
    content: 'The Language for Juniors programme transformed my classroom. Students who were previously shy and disengaged started raising their hands, telling stories, and helping each other. The EWRF volunteers brought an energy and dedication that inspired both the children and me as an educator. I\'ve seen lasting changes in my students\' confidence.'
  },
  {
    id: 3,
    initial: 'R',
    name: 'Rajan Kumaran',
    role: 'Volunteer • 8 Years of Service',
    content: 'I\'ve volunteered with many organisations, but EWRF is different. The training during induction was thorough – from child protection to counselling basics. I felt genuinely prepared to make a difference. Eight years later, I\'ve mentored over 30 students through CSI Plus, and every graduation feels personal. This is more than volunteering; it\'s a calling.'
  },
  {
    id: 4,
    initial: 'A',
    name: 'Anonymous',
    role: 'Counselling Service User',
    content: 'EWRF\'s free counselling service was a lifeline when my family was going through an incredibly difficult period. The counsellor was compassionate, professional, and never made me feel judged. Over several sessions, I gained tools to manage my anxiety and rebuild my confidence. I\'m grateful this service exists for people who can\'t afford private therapy.'
  },
  {
    id: 5,
    initial: 'D',
    name: 'Datuk Tan Cheng Hock',
    role: 'Corporate Sponsor',
    content: 'Our partnership with EWRF for the Treasure Hunt Charity event exceeded all expectations. The organisation was impeccable, the community engagement was genuine, and every ringgit raised went directly to programmes that change lives. As a corporate sponsor, I can say with confidence that EWRF is one of the most transparent and impactful NGOs in Malaysia.'
  }
];

export const galleryImages = [
  { id: 1, url: 'https://images.pexels.com/photos/18449721/pexels-photo-18449721.jpeg', category: 'Events', title: 'EWRF Charity Treasure Hunt' },
  { id: 2, url: 'https://images.pexels.com/photos/6647025/pexels-photo-6647025.jpeg', category: 'Programmes', title: 'Language for Juniors' },
  { id: 3, url: 'https://images.unsplash.com/photo-1560220604-1985ebfe28b1', category: 'Community', title: 'B40 Outreach' },
  { id: 4, url: 'https://images.pexels.com/photos/31864415/pexels-photo-31864415.jpeg', category: 'Volunteers', title: 'Volunteer Induction' },
  { id: 5, url: 'https://images.pexels.com/photos/31864451/pexels-photo-31864451.jpeg', category: 'Programmes', title: 'CSI Plus 21-Day Camp' },
  { id: 6, url: 'https://images.unsplash.com/photo-1557660559-42497f78035b', category: 'Events', title: 'Charity Golf 2026' },
  { id: 7, url: 'https://images.pexels.com/photos/7156169/pexels-photo-7156169.jpeg', category: 'Community', title: 'Community Workshop' },
  { id: 8, url: 'https://images.pexels.com/photos/7156163/pexels-photo-7156163.jpeg', category: 'Volunteers', title: 'Volunteer Training' }
];

export const videos = [
  {
    id: 1,
    thumbnail: 'https://images.unsplash.com/photo-1524178232363-1fb2b075b655',
    duration: '4:12',
    type: 'Documentary',
    title: '47 Years of Empowering Communities',
    description: 'A look at EWRF\'s journey from a small welfare group to a nationally recognised NGO.'
  },
  {
    id: 2,
    thumbnail: 'https://images.unsplash.com/photo-1582213782179-e0d53f98f2ca',
    duration: '2:45',
    type: 'Testimonial',
    title: 'Voices from L4J Students',
    description: 'Hear directly from primary school students whose confidence grew through Language for Juniors.'
  },
  {
    id: 3,
    thumbnail: 'https://images.pexels.com/photos/6646987/pexels-photo-6646987.jpeg',
    duration: '3:20',
    type: 'Event Coverage',
    title: 'CSI Plus Camp Highlights',
    description: 'Highlights from the latest 21-day residential camp for Standard 6 students.'
  }
];

export const events = [
  {
    id: 1,
    date: { day: '13', month: 'MAR', year: '2026' },
    status: 'past',
    title: '3rd EWRF Charity Treasure Hunt 2026',
    location: 'Midlands Convention Centre',
    description: 'Over 500 participants joined our flagship fundraiser, raising funds for CSI Plus and L4J programmes.',
    action: 'View Recap'
  },
  {
    id: 2,
    date: { day: '21', month: 'AUG', year: '2026' },
    status: 'upcoming',
    title: 'Charity Golf Tournament 2026',
    location: 'Saujana Golf & Country Club',
    description: 'An 18-hole charity tournament bringing together corporate sponsors and community supporters.',
    action: 'Register'
  },
  {
    id: 3,
    date: { day: '4', month: 'NOV', year: '2026' },
    status: 'upcoming',
    title: 'Annual Gala Dinner 2026',
    location: 'KL Convention Centre',
    description: 'An evening of celebration, awards, and fundraising featuring keynote speakers and cultural performances.',
    action: 'Register'
  }
];

export const partners = [
  { id: 1, name: 'NLFCS', logo: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/partner_nlfcs.jpg` },
  { id: 2, name: 'MySkills', logo: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/partner_myskills.jpg` },
  { id: 3, name: 'Ministry of Education Malaysia', logo: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/partner_ministry_of_education.jpg` },
  { id: 5, name: 'Jeffrey Cheah Foundation', logo: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/partner_jeffrey_cheah_foundation.jpg` },
  { id: 6, name: 'Combine Energy', logo: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/partner_combine_energy.jpg` },
  { id: 7, name: 'Shopee', logo: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/partner_shopee.jpg` },
  { id: 8, name: 'Sentosa 4D Magix', logo: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/partner_sentosa_4d.jpg` },
  { id: 9, name: 'Pancha', logo: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/partner_pancha.png` },
  { id: 10, name: 'Pavas', logo: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/partner_pavas.png` },
  { id: 11, name: 'Tourism Malaysia', logo: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/partner_tourism_malaysia.png` },
  { id: 12, name: 'MBPJ', logo: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/partner_mbpj.png` },
  { id: 13, name: 'APS', logo: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/partner_aps.png` },
  { id: 14, name: 'Rollti', logo: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/partner_rollti.png` },
  { id: 15, name: 'The Liquidator', logo: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/partner_theliquidator.png` },
  { id: 16, name: 'Yasna', logo: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/partner_yasna.png` },
  { id: 17, name: 'Amari', logo: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/partner_amari.png` },
  { id: 18, name: 'Majlis Bandaraya Melaka', logo: `${process.env.REACT_APP_BACKEND_URL}/api/uploads/partner_majlis_bandaraya_melaka.png` }
];

export const donationTiers = [
  { amount: 'RM 50', description: 'One week of Language for Juniors classes', icon: '📚' },
  { amount: 'RM 100', description: 'One professional counselling session', icon: '💬' },
  { amount: 'RM 500', description: 'CSI Plus camp sponsorship for one student', icon: '🏕️' },
  { amount: 'RM 1,000', description: 'Monthly B40 family welfare aid', icon: '🏥' },
  { amount: 'RM 2,500', description: 'Full volunteer induction training cycle', icon: '🤝' }
];
